// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import "@/styles/index.scss"; // global css
import VueRouter from "vue-router";
import routes from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/iconfont/iconfont.css";
import "@/utils";
import { flat2, findPath } from "@/utils";
import Axios from "axios";
import "./components/importComponents";
Vue.use(VueRouter);
Vue.use(ElementUI);

let router = new VueRouter({
  routes
});
Vue.config.productionTip = false;
Vue.axios = Vue.prototype.$axios = Axios;
// Axios.defaults.baseURL = 'http://192.168.31.21/v1';
//  Axios.defaults.baseURL = 'http://eitpm.wellinte.com/v1';
// Axios.defaults.baseURL = "/v1"
Axios.defaults.baseURL = process.env.BASE_API;
// Axios.defaults.baseURL = "http://192.168.31.202:8091/";
Axios.defaults.headers.post["Content-Type"] = "application/json";

window.siamEnabled = Vue.siamEnabled = true;
window.siamLoginUrl = "/v1/SSO/GLO/Redirect";
Vue.siamHandled = false;
window.hasSiamError = false;

if (Vue.siamEnabled) {
  let params = new URLSearchParams(location.search);

  let error = params.get("error");
  if (error == "noAppAccount") {
    alert("您未开通登录权限，请向有关部门申请。点击关闭页面");
    window.pener = null;
    // window.open("about:blank", "_self");
    window.close();
    window.hasSiamError = true;
  } else if (error == "disabled") {
    alert("您的账号已被禁用，请联系管理员开通。点击关闭页面");
    window.pener = null;
    // window.open("about:blank", "_self");
    window.close();
    window.hasSiamError = true;
  }

  let uid = params.get("userId");
  let token = params.get("token");
  if (uid && token) {
    sessionStorage.setItem("token", JSON.stringify(token));
    Vue.uid = uid;
  }
}
const auth = JSON.parse(sessionStorage.getItem("token"));
if (auth) {
  Axios.defaults.headers.common["Authorization"] = "Bearer " + auth;
}

Vue.prototype.setToken = function(token) {
  sessionStorage.setItem("token", JSON.stringify(token));
  Axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};
Vue.prototype.resetSetItem = function(key, newVal) {
  if (key === "watchStorage") {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent("StorageEvent");
    const storage = {
      setItem: function(k, val) {
        sessionStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent(
          "setItem",
          false,
          false,
          k,
          null,
          val,
          null,
          null
        );
        // 派发对象
        window.dispatchEvent(newStorageEvent);
      }
    };
    return storage.setItem(key, newVal);
  }
};

function gotoMenu(userId) {
  Vue.axios.get("/menus/top?recursion=true").then(({ data }) => {
    if (data.code === 0) {
      let _vue = window.$vue;
      _vue.items = flat2(data.data);
      if (_vue.items.length > 0) {
        Vue.siamHandled = true;
        _vue.$router.push(`/${findPath(_vue.items)}`);
        location.search = "";
        //                                callback()
      } else {
        // location.search = ''
        alert("没有使用权限，请联系管理员。点击关闭页面");
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("userInfo");
        Vue.axios.post("/users/logout").finally(() => {
          // location.href = window.siamLoginUrl
          // alert('您未开通登录权限，请向有关部门申请。点击关闭页面')
          window.pener = null;
          // window.open("about:blank", "_self");
          window.close();
        });
      }
    } else {
      throw new Error("error");
    }
  });
}

function loadUserInfo(userId, callback) {
  if (userId) {
    Vue.axios
      .get(`/users/${userId}`)
      .then(({ data }) => {
        if (data.code === 0) {
          sessionStorage.setItem("userInfo", JSON.stringify(data.data));
          return data.data.id;
        } else {
          throw new Error("error");
        }
      })
      .then(id => {
        gotoMenu(id);
      });
  } else {
    let s = sessionStorage.getItem("userInfo");
    if (s) {
      gotoMenu(JSON.parse(s).id);
    } else {
      callback();
    }
    Vue.siamHandled = true;
  }
}

router.beforeEach((to, from, next) => {
  const auth = JSON.parse(sessionStorage.getItem("token"));
  if (to.meta.requireAuth) {
    if (auth) {
      if (window.hasSiamError) {
        window.pener = null;
        // window.open("about:blank", "_self");
        window.close();
      } else if (Vue.siamEnabled && !Vue.siamHandled) {
        // next();
        loadUserInfo(Vue.uid, () => next());
        return;
      } else {
        next();
      }
    } else {
      next({
        path: "/login",
        query: {
          redirect: location.hostname //跳转登录页的时候传一个域名在登录页判断
          // redirect: to.fullPath // 将跳转的路由path作为参数，登录成功后跳转到该路由
        }
      });
    }
  } else {
    if (window.hasSiamError) {
      window.pener = null;
      // window.open("about:blank", "_self");
      window.close();
    } else if (Vue.siamEnabled && !Vue.siamHandled) {
      if (auth) {
        if (to.path == "/login") {
          loadUserInfo(Vue.uid, () => next("/index"));
          return;
        } else {
          next();
        }
      } else {
        next();
      }
    } else {
      if (to.name === "login") {
        if (auth) {
          next({
            path: from.fullPath
          });
        } else {
          next();
        }
      } else {
        next();
      }
    }
  }
});

/* eslint-disable no-new */
window.$vue = new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js